import React, { useEffect, useState } from 'react'
import TableWrapper from '../../../../component/TableWrapper';
import { Icons } from '../../../../assets';
import NormalSelect from '../../../../component/NormalSelect';
import Exported from '../../../../service/endpoints';
import request from '../../../../service';
import { Toast } from '../../../../service/toast';
import { saveLoadingState } from '../../../../redux/reducers/loadingSlice';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import GetUserPermission from '../../../../component/GetUserPermission';

const RewardsList = (props) => {

    const { programList = {}, setPage, isLoading, getRewardList, sortConfig, setSortConfig } = props
    const ACTIVE = 'Active'
    const IN_ACTIVE = 'Inactive'
    const dropdownList = [
        { label: ACTIVE, value: [ACTIVE] },
        { label: IN_ACTIVE, value: [IN_ACTIVE] },
    ]
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const deletePermission = GetUserPermission({ key: 'delete' });
    const editPermission = GetUserPermission({ key: 'edit' });

    const userHeader = [
        { label: 'Rewards', sortable: 'title' },
        { label: 'Points Required' },
        { label: 'Status' },
        { label: 'Actions' },
    ];


    const handleStatus = async (id, value) => {
        dispatch(saveLoadingState(true))
        let url = `${Exported.Endpoints.getRewardByID}/${id}`

        const requestData = {
            status: value == ACTIVE ? true : false,
        }
        await request({
            url: url,
            method: Exported.APIMethods.PUT,
            data: requestData
        }).then(async (res) => {
            if (res?.data?.status) {
                await getRewardList()
                Toast({
                    type: 'success',
                    message: 'Status updated successfully'
                })
            }
        }).catch((err) => {
            console.log(err, "err")
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            })
        })
        dispatch(saveLoadingState(false))
    }

    const handleDelete = async (id) => {
        dispatch(saveLoadingState(true))
        let url = `${Exported.Endpoints.getRewardByID}/${id}`

        const requestData = {
            id: id,
        }
        await request({
            url: url,
            method: Exported.APIMethods.DELETE,
            data: requestData
        }).then(async (res) => {
            if (res?.data?.status) {
                await getRewardList()
                Toast({
                    type: 'success',
                    message: 'Deleted successfully'
                })
            }
        }).catch((err) => {
            console.log(err, "err")
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            })
        })
        dispatch(saveLoadingState(false))
    }

    const handleData = (keyValue, defaultValue, className = '') => {
        return (
            <td className={`${className}`}>{keyValue ? keyValue : defaultValue}</td>
        )
    };

    // const handleRewards = (keyValue, defaultValue, className = '', index) => {
    //     return (
    //         <td className={`${className}`}>
    //             <div className={`${classes.rewardsColumn}`} onClick={() => handleView(index)}>{keyValue ? keyValue : defaultValue}</div>
    //         </td>
    //     )
    // };

    const redirectTo = (id) => {
        navigate(`?id=${id}`)
    }

    const redirectToEdit = (id) => {
        navigate(`?type=edit?id=${id}`)
    }

    return (
        <>
            <div className={`eventWrapper`}>
                <div className={`mt-2 mb-5`}>
                    <TableWrapper
                        headerDetails={userHeader}
                        pageMeta={programList?.pageMeta}
                        handlePageChange={setPage}
                        listLength={programList?.result || []}
                        isLoading={isLoading}
                        sortConfig={sortConfig}
                        setSortConfig={setSortConfig}
                    >
                        {programList?.result?.map((item, index) => {
                            const { title = '', points, status = '', id = '' } = item;
                            return (
                                <tr key={title}>
                                    {handleData(title, '-', 'text-left')}
                                    {handleData(points, '-', 'text-center')}
                                    {/* {handleRewards(rewards, '-', 'text-center', index)} */}
                                    <td className=" px-3 mx-auto text-center w-[130px]">
                                        <div className=' '>
                                            <NormalSelect
                                                className={`w-[100%] p-0`}
                                                list={dropdownList}
                                                value={status ? ACTIVE : IN_ACTIVE}
                                                handleChange={(e) => e !== status ? handleStatus(id, e) : null}
                                                highLight
                                                highLightColor={
                                                    status ? "#01CB46" :
                                                        "#FC0000"
                                                }
                                                placeholder="Status"
                                            />
                                        </div>
                                    </td>
                                    <td className=" px-3 mx-auto text-center action-button">
                                        <div className='flex items-center justify-center'>
                                            <img src={Icons.eye} alt='View' className='cursor-pointer w-[20px] h-[20px] mr-2' onClick={() => redirectTo(id)} />
                                            {editPermission && <img src={Icons.edit} alt='Edit' className='cursor-pointer w-[18px] h-[16px] mr-2' onClick={() => redirectToEdit(id)} />}
                                            {deletePermission && <img src={Icons.delete} alt='Delete' className='cursor-pointer w-[20px] h-[18px]' onClick={() => handleDelete(id)} />}
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                    </TableWrapper>
                </div>
            </div>
        </>
    )
}

export default RewardsList